import styled from 'styled-components';

import Button from 'web-components/Button';

export const Close = styled(Button).attrs({
  appearance: 'link',
})`
  color: #000000;
  font-size: 24px;
  font-weight: normal;
  text-shadow: none;
  opacity: 0.7;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  position: absolute;
  top: -15px;
  right: -5px;
  z-index: 9;

  &:hover {
    opacity: 0.9;
  }
`;

export const PrimaryButton = styled(Button).attrs({
  fit: true,
  type: 'button',
  appearance: 'success',
})`
  font-size: 18px;
  display: block;
  border-radius: 20px;
  padding: 6px 25px;
`;
